const i18n = {
    lang: "en_us",
    copyright1: "Copyright @2007-",
    copyright2: " Dayee Cloud Computing co., LTD. All Rights Reserved.",
    systemName: "Intelligent Video Interview System",
    pageTitle: {
        index: "Homepage",
        check: "Equipment Inspection",
        record: "Recording Officially",
        tryRecord: "Audition",
        feedback: "Feedback"
    },
    result: {
        title: "One Way Video Interview Results",
        interviewTitle: "Interview Info",
        recordStatus: "Recording Status",
        recordComplete: "Completed",
        submitStatus: "Submit Status",
        finishTime: "Submit Time",
        finishTimes: "Submission Time",
        totalFileDuration: "Total Time-Video",
        startTime: "Start Time",
        endTime: "End Time",
        postName: "Applied position",
        paperName: "Interview Papers",
        questionNum: "Questions Amount",
        videoResource: "Video Source",
        fileStatus: "Video File Status",
        fileExist: "Existent",
        fileNotExist: "Inexistent",
        videoTitle: "Questions & Video Play",
        recordNotFinish: "Video interview has not been finished yet, please check again after completion.",
        moreBtnText: "View Profile",
        videoTime: 'Video Time',
        total: 'There are {num} questions in total',
        summaryTitle: 'Summary of video analysis conclusion',
        summaryInfo: 'Proportion of emotion',
        summaryDetailTitle: 'Video analysis details',
        emotionInfo: 'Emotion of each question',
        analysisInfo: 'Analysis of each question',
        personalityInfo: 'Description of personality traits',
        characteristicsInfo: 'Job characteristics suitable for ${type} type',
        occupationInfo: 'Suitable occupation for ${type} type person',
        realTimeInfo: 'Real time video analysis',
        upText: 'open',
        downText: 'close',
        lastQue: 'Last question',
        nextQue: 'Next question',
        expressText1: 'Useful',
        expressText2: 'Useless'
    },
    check: {
        title: "Intelligent video interview equipment detection",
        subtitle: "Please test and confirm that the equipment and network you use during the interview meet the requirements. If not, please replace it as soon as possible according to the instructions.",
        browser: "Browser",
        browserInfo: "Support browser version for Google 58+, firefox 56+ and Safari 11+. If not, please install the required version.",
        network: "Network Detection",
        networkInfo: "Please keep 100Kbps and above. If not, please check the network status.",
        microphone: "Microphone",
        microphoneInfo: "Please ensure the normal use of the microphone. If not, please check the microphone Settings.",
        camera: "Camera",
        cameraInfo: "Please ensure the normal use of the camera. If not, please test the camera Settings",
        pendingStatus: "In detection",
        passedStatus: "Passed",
        failedStatus: "Failed",
        btnText: "Enter"
    },
    startInterviewModal: {
        title: "Start Interview",
        content1: "If you have not participated in the intelligent video interview,",
        content2: "please select audition for an interview experience.",
        cancelText: "Audition",
        okText: "Start Recording Officially"
    },
    privacyModal: {
        detailBtnText: "View Details",
        okText: "Agree & Continue",
        cancelText: "Disagree"
    },
    index: {
        title: "Hello! ",
        titleTips: "(If not yourself, please exit the applet immediately.)",
        titlePCTips: "(If it isn't yourself, please exit the applet immediately.)",
        subtitle1: "Welcome to ",
        subtitle2: " video interview system",
        subtitlePC1: "Welcome to ",
        subtitlePC2: " video interview system",
        positionText: "The position you are interviewing for is",
        tryVideoBtnText: "Audition Once",
        recordBtnText: "Start",
        instructionsText1: "I have read ",
        instructionsText2: '"video interview recording instructions".',
        instructionsTips: 'Please read "video interview recording instructions" first.',
        checkBtnText: "Test Recording Device",
        skipBtnText: "Skip",
        notSuportMobileText: "Please go to WeChat to scan the code and open the mini program",
        browserNotSuportText: "Video interview is not supported in your browser.Please change to a new version of Chrome or Safari browser for video interview!"    //, qq
    },
    noticeModal: {
        okText: "I see. Start recording."
    },
    ajustModal: {
        title1: "Please adjust the camera to the proper position",
        title2: "to expose the facial features.",
        btnText: "Well done!"
    },
    tryFinish: {
        title: "End Audition",
        subtitle1: "Congratulations on your completing interview audition vedio recording. Trial recording video is not saved,and it is only for the use of process experience.",
        subtitle2: "Please click the button below to start the vedio interview recording. Note: try not to interrupt after the beginning!",
        btnText: "Enter the formal recording"
    },
    question: {
        questionTitle: "Thinking time remaining",
        questionSubtitle: "The answer time does not exceed",
        minute: "minute",
        second: "second",
        questionText: "Question",
        demo: "Do you prefer a research or a practical job?"
    },
    record: {
        loadingText: "loading",
        startText: "Start",
        recordText: "Countdown",
        recordTextPC: "The remaining time",
        recordTextPC1: "Countdown",
        endText: "End",
        endTextPC: "End this Term",
        timeLimitText: "The recording time shall be no less than 10s",
        stopingText: "Is ending...",
        recordFailText: "Failed. Please record again.",
        poorVideoQuality: "Our system detected that the recorded video is of poor quality. It is recommended to re-record  in stable network condition.",
        rerecordLimitText: "The re-record times has reached the  limit. Please submit.",
        replayLimitText: "The playback times has reached the limit。 Please re-record  or submit."
    },
    stopRecordModal: {
        title: "End Recording",
        playbackText: "Playback",
        rerecordText: "Record again",
        confirmTitle: "If you click on Record again",
        confirmSubtitle: "your new recording will overwrite the existing one",
        confirmRed: "Number of attempts remaining: ",
        confirmBtnCancel: "Cancel"
    },
    replayModal: {
        title: "End Audition",
        playbackText: "Playback",
        rerecordText: "Record again",
        okText1: "Submit",
        okText2: "Submit. Next question",
        okText3: "Submit and complete the recording",
        autoText: "Auto Submit",
        replayFailText: "Failed to get video!"
    },
    replay: {
        btnText: "End Playback"
    },
    finish: {
        title: "Video submitted successfully",
        subtitle1: "Congratulations on completing your ",
        subtitle2: " video interview with ",
        subtitle3: ",Please wait for HR's reply."
    },
    evaluate: {
        title: "Interview experience", //"This interview experience",
        tag1: "Experience is good",
        tag2: "Smooth network",
        tag3: "Convenient and quick",
        placeholder: "If you have any comments or Suggestions, please fill in here",
        btnText: "Submit evaluation",
        successTitle: "Submit evaluation successfully",
        successSubtitle: "Thank you for your feedback on the interview experience.",
        exitText: "I see.",
        scoreTitle: "Experience Scores",
        scoreText: "points",
        tagTitle: "Experience Impression",
        textareaTitle: "Suggestions"
    },
    globalStatus: {
        status1Text1: "The interview has not started yet, please be patient.",
        status1Text2: "Interview Time",
        status2Text1: "The interview is over.",
        status2Text2: "If you still need video interview, please contact HR.",
        status2Text3: "Interview Time",
        status3Text1: "You will resume from the last question.",
        status3Text2: "Number of access to platform ",
        status3Text3: "remaining: ",
        status3Text4: " attempt(s).",
        status4Text1: "Unfortunately, re-enter have been used up.",
        status4Text2: "For further video interview, please contact HR.",
        status5Text1: "You have recorded using a PC link.",
        status5Text2: "Please click the PC link to continue the operation.",
        status6Text1: "Microphone or camera are not stared.",
        status6Text2: "Please authorize access in Settings.",
        status6Text3: "After the permission is opened, please exit the applet and enter again.",
        status7Text1: "Invalid Account",
        status7Text2: "If you still need video interview, please contact HR.",
        status8Text1: "You have recorded using a small program.",
        status8Text2: "Please scan the code to continue operation.",
        status9Text1: "Microphone and camera are not authorized, please try the following methods:",
        status9Text2: "Top right menu - Settings - Advanced - Content Settings - Microphone/Camera - Ban - ",
        status9Text21: ":443- Delete on the right",
        status9Text3: "1.Refresh. If the authorization prompt box appears, please click the button【allow】.",
        status9Text4: "2.Top right menu - Options - Privacy and Security - Authorization - Microphone/Camera - Settings - ",
        status9Text41: ":443- Allow - Save changes",
        status9Text5: "2.Top left corner: Safari- Preferences - Website - Microphone/Camera - Apply/Allow",
        statusBtnText1: "I see.",
        statusBtnText2: "Continue",
        statusBtnText3: "To set up",
    },
    device: {
        title: "The video interview has been conducted on other devices.",
        subtitle1: "If the interview is not conducted by yourself,",
        subtitle2: "please contact HR in time.",
        btnText: "I see.",
		kickOtherBtn: "I will answer on this device",
    },
    lowVersion: {
        title: "The current WeChat version does not support video recording,",
        subtitle: "please update to the latest version and re-enter.",
        btnText: "I see."
    },
    network: {
        title: "Network Error",
        btnText: "Reload"
    },
    tips: {
        title: "This applet is only for video interviews.",
        subtitle: "Sorry,you have not been arranged this interview yet.",
        btnText: "I see."
    },
    showModal: {
        title: "Tips",
        titlePC: "Tips"
    },
    globalError: {
        equipmentNotFound: "Equipment not detected.",
        browserNotSurport: "The browser does not support getting access to the camera and microphone.",
        unknowError: "unknown error",
        btnText: "I see."
    },
    report: {
        uploadSuccess: "Upload video succeeded!",
        uploadFail: "Upload video failed!",
        generateReport: "Generate Report",
        download: "Download Report",
        viewReport: "View Report",
        generate: "Being generated...",
        originalVideo: "Original",
        liveAnalysis: "Live analysis",
        analysisReport: "Report",
        reportGenerate: "Live analysis and report are being generated...",
        reportFail: "Request failed, please contact your consultant",
        summary: "Video Summary",
        emotions: "Emotions Average",
        characteristics: "Characteristics Average",
        mapping: "Mapping",
        RIASECModel: "RIASEC model",
        liveEmotions: "Live Emotions",
        liveCharacteristics: "Live Characteristics",
        angry: "Angry",
        happines: "Happiness",
        fear: "Fear",
        disgust: "Disgust",
        contempt: "Contempt",
        neutral: "Neutral",
        surprise: "Surprise",
        sadness: "Sadness",
        honesty: "Honesty",
        confidence: "Confidence",
        curiosity: "Curiosity",
        passion: "Passion",
        judging: "Judging",
        disagree: "Disagree",
        nervousness: "Nervousness",
        angryInfo1: "A feeling of tension and hostility, usually caused by anxiety aroused by a perceived threat to one's self, possessions, rights, or values.",
        angryInfo2: "Anger face works so well because each facial movement makes a person look physically stronger, according to researchers. This face lets the threat know we mean business. It's one of our most powerful emotions and it shows just how expressive the human face can be. This face serves as a warning, whether it's simply to intimidate or to show that a conflict has begun.",
        happinesInfo1: "Happiness is a mental or emotional state of well-being which can be defined by, among others, positive or pleasant emotions ranging from contentment to intense joy.",
        happinesInfo2: "Despite the friendly connotation, researchers believe our smiles might have a more sinister origin. Many primates show their teeth to assert their dominance and lock down their status in their social structure. Some researchers believe it is that non-verbal sign that eventually evolved into a smile.",
        fearInfo1: "The unpleasant emotional state consisting of psychological and psychophysiological responses to a real external threat or danger.",
        fearInfo2: "Each fear-based facial movement prepares us for a fight-or-flight response. This facial expression capitalizes off of the way our bodies work. Widening our eyes opens up our field of vision and lets in more light, allowing us to see the threats around us. The same can be said for our oxygen pathways. Opening our nostrils increases our oxygen intake and helps us prepare to flee or fight.",
        disgustInfo1: "An emotional response of revulsion to something considered offensive, distasteful, or unpleasant.",
        disgustInfo2: "The disgust face doesn’t just show our distaste, it also works to protect us. Wrinkling the nose closes the nasal passage, protecting it from dangerous fumes, and squinting our eyes shields them from damage.",
        contemptInfo1: "The feeling or attitude of regarding someone or something as inferior, base, or worthless.",
        contemptInfo2: "Although the emotion of contempt can overlap with anger and distrust, the facial expression is unique. It is the only expression that occurs on only one side of the face and can vary in intensity. At its strongest, one brow may lower while the lower eyelid and lip corner rise on the same side. At its most covert, the lip corner might only rise briefly.",
        neutralInfo1: "It is a state of psychological stability and composure which is undisturbed by experience of or exposure to emotions, pain, or other phenomena that may cause one to lose the balance of his/her mind.",
        neutralInfo2: "However, neutrality does not mean the subject has no emotions – it covers a range in the middle part of the spectrum of felt experience. In between pain and pleasure, an area in the affective tonality of experience appearing as relatively bland and neither distinctly painful nor clearly pleasant, or comparatively neutral biographical information with no dominant emotion.",
        surpriseInfo1: "A startle response experienced by animals and humans as the result of an unexpected event.",
        surpriseInfo2: "While the surprise expression might only last a second or two, the facial movements — particularly the raised eyebrows — allow us to take in our surroundings, shift our attention to another, possibly threatening event, and react quicker. Whether it's a good or bad surprise, the facial reaction is the same.",
        sadnessInfo1: "Sadness is an emotional pain associated with, or characterized by, feelings of disadvantage, loss, despair, grief, helplessness, disappointment and sorrow.",
        sadnessInfo2: "Sadness is hard to fake, according to researchers. One of the telltale signs of sadness is the inner-brow raise, which very few people can do on demand.",
        honestyInfo1: "Measures the degree to which the subject believes in his/her own worth and abilities and how comfortable he/she is in their own skin. It measures the degree to which the subject believes in positive outcomes for themselves rather than dwelling on negative outcomes, such as failure or other people’s opinions.",
        honestyInfo2: "Trait description: Maintains self-control and personal belief in a successful outcome; Is positive about themselves and what the future will bring.",
        confidenceInfo1: "Reflects a quest for truthfulness rather than deceit in thought and action. Focuses on the conditions under which individuals respond truthfully in their interactions and reaction.",
        confidenceInfo2: "Trait description: Straightforward in dealing with others; Avoids deceiving others.",
        curiosityInfo1: "Measures the subject’s levels of interest in continuous learning, finding solutions, and in intellectual challenge. It measures their motivation to explore the world around them and to acquire new knowledge and skills, regardless of whether this takes them outside of their comfort zone. Being curious also means being able to question and challenge others.",
        curiosityInfo2: "Trait description: Broad intellectual focus; Fascinated by unusual people's actions and feelings; Interested in why things appear different to the norm.",
        passionInfo1: "Measures the subject’s levels of strong emotions, enthusiasm and dedication towards the subject matter discussed.",
        passionInfo2: "Trait description: Crave excitement; Focussed on what they want and driven to achieve it.",
        nervousnessInfo1: "Measures the degree to which the subject displays signs of unease and anxiety.",
        nervousnessInfo2: "Trait description: Uneasy; Struggling to stay calm under stressful conditions; Unable to maintain their composure in certain situations.",
        mappingObj: {
            headerText1: "Big 5 Personality Dimension",
            headerText2: "Characteristics",
            headerText3: "Emotion",
            stressReaction: "Stress Reaction",
            outgoing: "Outgoing",
            creativity: "Creativity",
            agreeableness: "Agreeableness",
            conscientiousness: "Conscientiousness",
            extravesion: "Extravesion",
            selfConfidense: "Self-confidense",
            innovation: "Innovation",
            empathy: "Empathy",
            disagreeing: "Disagreeing",
            trust: "Trust",
            easyGoing: "Easy-Going"
        },
        riasecModel: {
            infoText1: "Holland's RIASEC model encompasses 6 career themes: Realistic; Investigative; Artistic; Social; Enterprising and Conventional. The meta-analyses showed the mean effect sizes for each of the 30 correlations between the six interest dimensions and the five personality dimensions. Of the 30 correlations, 5 appeared to be substantial for both women and men across the interest measures.",
            infoText2: "It's also possible to hypothesis which Big Five score ranges correlate with effective job performers in the following popular job roles:",
            low: "LOW",
            med: "MED",
            high: "HIGH",
            stressReactionText1: "Business Manage; Sales rep; CEO; Police Officer; Finance",
            stressReactionText2: "Business Consultant; Facilitator; HR",
            stressReactionText3: "Social Worker; Customer Rep; Flight Cabin Crew",
            outgoingText1: "Writer; Researcher; Accountant; Engineer; Lab Technician; Clerical Worker; Data Entry; Admin; Lawyer; Bookkeeper; IT",
            outgoingText2: "Teacher; Consultant; Receptionist",
            outgoingText3: "Sales rep; Business Leader; Barrister; Trainer; Hotel Manager; Agent; Public Relations; Marketing Manager",
            creativityText1: "Technician; Clerical Worker; Electrician; Plumber; Carpenter; Data Entry; Clerk; Doctor; IT support/repairs",
            creativityText2: "Team Leader; Human Resources; Facilitator",
            creativityText3: "Consultant; Advertising Executive; Healthcare; Worker; Writer; Artist; Designer",
            agreeablenessText1: "Politician; Business Owner; Entrepreneur; Police Officer; Barrister; Judiciary",
            agreeablenessText2: "Facilitator; Negociator",
            agreeablenessText3: "Carer; Lecturer; Social Worker",
            conscientiousnessText1: "Admin Support; Waiter/Waitress; Factory Worker; Postal Staff; Builder; Maintenance Worker",
            conscientiousnessText2: "Team Leader; Senior Business Manager",
            conscientiousnessText3: "Supervisor; Customer Service/Sales Repesentative; Accountant; Proof-Reader; Editor; Statistician"
        },
        emotion: {
            surprise: 'surprised',
            happiness: 'happiness',
            neutral: 'neutral',
            sadness: 'sadness',
            disgust: 'disgust',
            anger: 'anger',
            fear: 'fear',
            contemplation: 'contemplation',
            attention: 'attention'
        },
        strong: 'strong',
        weak: 'weak',
        summaryInfo1: 'AI video interview analysis showed that the subjects\' attention score was ${num}, with ${degree} attention',
        summaryInfo2: 'Professional character:',
        summaryInfo3: 'score',
        summaryInfo4: 'Expression intensity',
        summaryInfo5: 'emotion',
        questionNum: 'Question ${num}',
        questionTotal: '(a total of ${num})'
    }
}

export default i18n;
